module.exports = __webpack_public_path__ + "a3bd63f8888016da8bb8aebc2922822e.png";